import { formatPrice } from "../../../../../../common-deprecated/Globalize";
import type { ServiceProductType } from "../../../../../../common-deprecated/types/CommonTypes";
import { find } from "../../../../../../common-deprecated/utils";
import { addServiceProduct, removeServiceProduct } from "../../../redux/actions/BasketActions";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

type UseServiceProductType = {
    actions: {
        selectServiceProduct: () => void;
        deSelectServiceProduct: () => void;
    };
    serviceProductContent: {
        selected: boolean;
        price: string;
    };
};

const useServiceProduct = (serviceProduct: ServiceProductType): UseServiceProductType => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const basket = useBnbSelector((state) => state.basket);
    const formattedPrice = formatPrice(serviceProduct.price.cash, commonSettings.culture.name);

    const isSelected = !!find(serviceProduct.id, basket.serviceProducts);

    const actions = {
        selectServiceProduct: (): void => {
            dispatch(addServiceProduct(serviceProduct, true, true));
        },
        deSelectServiceProduct: (): void => {
            dispatch(removeServiceProduct(serviceProduct, true));
        },
    };

    return {
        actions,
        serviceProductContent: {
            selected: isSelected,
            price: formattedPrice,
        },
    };
};

export default useServiceProduct;
